import React from "react";

const LayoutContext = React.createContext<{ isModal: boolean }>({
  isModal: false,
});

export const useLayoutContext = () => React.useContext(LayoutContext);

export default LayoutContext;
